export const mapResponse400 = (): null => null;
